import * as React from "react";
import type { SVGProps } from "react";
import { Ref, forwardRef } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgValidationCheckBold32 = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps, ref: Ref<SVGSVGElement>) => <svg width={32} height={32} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} aria-labelledby={titleId} {...props}>{title ? <title id={titleId}>{title}</title> : null}<path d="M7.33325 16.5897C9.67955 18.1957 13.8326 22.9385 15.1375 26C17.1199 19.1995 22.2642 9.4128 24.8991 6" stroke="currentColor" strokeWidth={2.4} strokeLinecap="square" /></svg>;
const ForwardRef = forwardRef(SvgValidationCheckBold32);
export default ForwardRef;